<template>
    <div class="video-element">
        <div class="video-wrapper">
            <video
                ref="video"
                controls
                controlsList="nodownload"
                :src="src"
            />
        </div>
        <div class="caption">
            <slot />
        </div>
    </div>
</template>

<script>

export default {
    name: 'VideoElement',
    props: {
        src: {
            type: String,
            required: true
        }
    },
    mounted()
    {
        this.$refs.video.addEventListener('loadeddata', () =>
        {
            this.$el.style.opacity = 1;
        });
    },
    destroyed()
    {
        const {video} = this.$refs;
        video.pause();
        globalThis.setTimeout(() =>
        {
            video.src = '';
            video.load();
        }, 1000);
    }
};
</script>

<style lang="scss" src="./VideoElement.scss" />

